/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
var $grid_sizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600"
};

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

var isMobile = false; // initiate as false
var isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  isMobile = true;
  $("body").addClass("isMobile");
}

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

function links__init() {
  var $links = $("a").not(".noline, .noline a, .line--added, .cli-bar-btn_container a");

  if ($links.length > 0) {
    $links.each(function () {
      var $this = $(this);
      var $icon = $(".fa, .fas, .far, .fal, .fab", $this);

      if ($("img", $this).length < 1) {
        $this.wrapInner("<span class='linkline'>");
        $this.addClass("line--added");
        if ($icon.length > 0) {
          if ($icon.hasClass("fa--left")) {
            $icon.insertBefore($(".linkline", $this));
          } else {
            $icon.insertAfter($(".linkline", $this));
          }
        }
      }
    });
  }
} // links__init()

links__init();

/*  ==========================================================================
		Enable Iframe resizer for Salesforce forms
		- For this to work the script also needs to be called within the iframe (e.g. in Salesforce)
		- the tutorial for this is here: https://jennamolby.com/how-to-embed-a-pardot-form-on-your-website-the-right-way/
		========================================================================== */
window.setTimeout(function () {
  iFrameResize();
}, 600);

/*  ==========================================================================
		GENERAL - Seperate text in buttons for hover animation
		========================================================================== */

function btns__init() {
  var $btns = $(".btn:not(.nf-fu-fileinput-button)");
  $btns.each(function () {
    var $this = $(this);
    var $icon = $(".fa, .fas, .far, .fal, .fab", $this);
    if (!$this.find(".btn__textwrap").length) {
      // Add wrapping spans, if they are not already setup
      $this.wrapInner("<span class='btn__textwrap'>");
      $this.find(".btn__textwrap").wrapInner("<span class='btn__text'>");
      $this.find(".btn__text").clone().appendTo($this.find(".btn__textwrap"));
      if ($icon.length > 0) {
        if ($icon.hasClass("fa--left")) {
          $icon.insertBefore($(".btn__textwrap", $this));
        } else {
          $icon.insertAfter($(".btn__textwrap", $this));
        }
      }
    }
  });
} // btns__init()

btns__init();

// re-init buttons for form ready
jQuery(document).on("nfFormReady", function () {
  btns__init();
});

/*  ==========================================================================
    GENERAL - sharinglinks
    ========================================================================== */

$(".sharelink--popup").click(function (e) {
  e.preventDefault();
  window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
});

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

$(".accordion__question").click(function () {
  $(this).closest(".accordion__item").toggleClass("accordion__item--open");
  $(this).next().slideToggle();
});

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

plyrs__init();

function plyrs__init() {
  // Get all videos that are click to play
  var $plyrs = $(".mediavideo").not(".mediavideo--autoplay").not(".video-slider");

  if ($plyrs.length > 0) {
    $plyrs.each(function () {
      var plyr = $(this).find(".mediavideo__video");
      const vid = new Plyr(plyr, {
        controls: ["play", "progress", "mute", "current-time"],
        hideControls: true,
        invertTime: false,
        tooltips: { controls: false, seek: false }
      });
    });
  }
} // plyrs__init()

/*  ==========================================================================
    GENERAL - hide announcement banner on scroll 
    ========================================================================== */

if ($(".announcement").length) {
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $(".siteheader:not(.siteheader--padder)").addClass("siteheader--hideannouncement");
    } else {
      $(".siteheader:not(.siteheader--padder)").removeClass("siteheader--hideannouncement");
    }
  });
}

/*  ==========================================================================
    GENERAL - file input JS
    ========================================================================== */

$("body").on("change", ".hs-fieldtype-file .hs-input", function (e) {
  var labelVal = $(this).closest("label").innerHTML;
  var filename = "";
  if (e.target.files && e.target.files.length > 1) {
    filename = this.files.length + " Files";
  } else {
    filename = e.target.files[0].name;
  }

  if (filename) {
    $(this).closest(".hs-form-field").find("label span").html(filename);
  } else {
    $(this).closest(".hs-form-field").find("label span").html(labelVal);
  }
});

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
var lazyLoadInstance = new LazyLoad({
  callback_loaded: () => {
    Waypoint.refreshAll();
  }
});

/*  ==========================================================================
    GENERAL - Table content module
    ========================================================================== */
$(function () {
  // $('.tab-content:first-child').show();
  $(".table-content__list__link").bind("click", function (e) {
    var $this = $(this);
    // var $tabs = $this.parent().parent().next();
    var $target = $($this.data("target")); // get the target from data attribute
    $this.siblings().removeClass("active");
    $target.siblings().css("display", "none");
    $this.addClass("active");
    $target.fadeIn("fast");
    Waypoint.refreshAll();
  });
  $(".table-content__list__link:first-child").trigger("click");
});

/*  ==========================================================================
		NAVIGATION - Page nav - .pagenav
		- JS to highlight active item within pagenav on scroll
		- This uses Waypoints to get the scroll position: http://imakewebthings.com/waypoints/
		========================================================================== */

var $pagenav = $(".pagenav");
var $pagenav_anchors = $(".pagenav__anchor");
var $mobile_pagenav_anchors = $(".dropdown__list .scrolltolink");

if ($pagenav_anchors.length > 0 && $pagenav.length > 0) {
  pagenav__init();
}

function pagenav__trigger_active($pagenav, active_item) {
  if (active_item.length) {
    // Add new active class
    $(active_item).addClass("active");
    // Scroll to active item
    var active_item_offset = $(active_item).offset().left;
    var nav_offset = $(".pagenav__wrapper", $pagenav).offset().left;
    $(".pagenav__wrapper", $pagenav).animate({ scrollLeft: active_item_offset - nav_offset }, { duration: "medium" });
  }
}

function pagenav__init() {
  $pagenav_anchors.each(function () {
    var $el = $(this);
    var active_item;
    var $el_id = $el.attr("id");
    $el.waypoint({
      handler: function (direction) {
        if (direction === "down") {
          // Remove current active class
          $(".pagenav__link", $pagenav).removeClass("active");
          // Get active item
          active_item = $('.pagenav__link[href="#' + $el_id + '"]', $pagenav);
          pagenav__trigger_active($pagenav, active_item);
        } else {
          // Remove current active class
          $(".pagenav__link", $pagenav).removeClass("active");
          // Get active item
          active_item = $('.pagenav__link[href="#' + $el_id + '"]', $pagenav)
            .closest("li")
            .prev()
            .find(".pagenav__link");
          pagenav__trigger_active($pagenav, active_item);
        }
      },
      offset: "200px"
    });
  });

  if ($mobile_pagenav_anchors.length > 0) {
    $mobile_pagenav_anchors.on("click", function () {
      $(this).closest(".sitenav__item--hasdropdown").removeClass("sitenav__item--open");
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  }
} // pagenav__init()

/*  ==========================================================================
  Video Content Fancybox
  ========================================================================== */
$(".tile--video[data-fancybox]").fancybox({
  toolbar: "true",
  buttons: [
    //"zoom",
    //"share",
    //"slideShow",
    //"fullScreen",
    //"download",
    //"thumbs",
    "close"
  ],
  helpers: {
    title: { type: "inside" }
  },
  baseTpl:
    '<div class="fancybox-container fancybox-container--video" role="dialog" tabindex="-1">' +
    '<div class="fancybox-bg"></div>' +
    '<div class="fancybox-inner">' +
    '<div class="fancybox-title"></div>' +
    '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>' +
    '<div class="fancybox-toolbar">{{buttons}}</div>' +
    '<div class="fancybox-navigation">{{arrows}}</div>' +
    '<div class="fancybox-stage"></div>' +
    '<div class="fancybox-caption"><div class="fancybox-caption__body"></div></div>' +
    "</div>" +
    "</div>",
  beforeShow: function () {
    $(".caption--image").remove();
  },
  afterShow: function () {
    var caption = $(".fancybox-caption"),
      innerCaption = caption.clone().addClass("caption--image");

    $(".fancybox-slide--current .fancybox-content").append(innerCaption);
    caption.not(".caption--image").addClass("caption--bottom");
  }
});

$(".tile--video[data-fancybox]").click(function () {
  $(".fancybox-title").html($(this).data("title"));
});

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

if ($(".paging__loadmore").length) {
  $(".paging__loadmore").click(function () {
    var button = $(this);
    var data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    var button_text; // create variable to store button text

    // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        button_text = button.html(); // store current button text
        button.text("Loading..."); // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.html(button_text); // set back to previous button text
          $(".loadmore-container").append(data); // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
          // Re-init links to make sure linklines on newly loaded content still work
          links__init();
          // Re-init effects
          effects__init();
          // Re-init lazy load
          lazyLoadInstance.update(); // reinit lazy load after clones
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });
}

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

function effects__init() {
  var $effects = $(".effect");
  if ($effects.length > 0) {
    $effects.each(function () {
      var $el = $(this);
      var $waypoint = new Waypoint({
        element: $el,
        handler: function (direction) {
          if (direction === "down") {
            $el.addClass("effect--ready");
          } else {
            $el.removeClass("effect--ready");
          }
        },
        offset: "95%"
      });
    });
  }
} // effects__init()

effects__init();

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const default_animation_speed = 1.5;

const elClass = "logos__marquee--marquee";
const innerClass = "marquee__wrap";

const marqueeElements = document.querySelectorAll(".logos__marquee--marquee");

const marquee__reset = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init = function () {
  if (!marqueeElements) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements.forEach(function (el) {
      // Setup animation times
      marquee__resize(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements.forEach(function (el) {
    // If it's a logo marquee
    const tiles = el.querySelectorAll(".marquee__tile");
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil(minWidth / textWidth);

    const textToRepeat = el.innerHTML;

    for (let index = 1; index < timesToRepeat; index++) {
      el.innerHTML += textToRepeat;
    }

    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".logos__marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init);

/*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

const elClass_2 = "marquee";
const innerClass_2 = "marquee__wrap";

const marqueeElements_2 = document.querySelectorAll(".marquee");

const marquee__reset_2 = function (el) {
  const wrapElements = el.querySelectorAll("." + innerClass_2);

  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
  if (wrapElements[0].offsetWidth < minWidth) {
    // Getting the orginal items
    const originalNumItems = el.dataset.count ? el.dataset.count : 1;

    let orginalTiles = "";

    const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

    for (let index = 0; index < originalNumItems; index++) {
      orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
    }

    //Calculating how many times do we need to repeat the original tiles based of the width of the tile
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

    //Adding the extra tiles to the three wraps
    for (let index = 0; index < timesToRepeat; index++) {
      wrapElements[0].innerHTML += orginalTiles;
      wrapElements[1].innerHTML += orginalTiles;
      wrapElements[2].innerHTML += orginalTiles;
    }
  }
};

const marquee__resize_2 = function (el) {
  // Check if the marquee is large enought for the space
  marquee__reset_2(el);

  // Check if element has custom speed or default
  let animation_speed = default_animation_speed;
  if (el.dataset.speed) {
    animation_speed = el.dataset.speed;
  } else {
    animation_speed = default_animation_speed;
  }

  const wrapElements = el.querySelectorAll("." + innerClass_2);

  // Calculate the animation time and delay for each wrap
  let linelength = wrapElements[0].offsetWidth;
  let distance = linelength;
  let speed = animation_speed * 0.01;
  let duration = distance / speed;

  let delay = 0 - duration / 3;

  wrapElements.forEach(function (wrap, index) {
    let count = index + 1;
    wrap.style.animationDuration = duration + "ms";
    wrap.style.animationDelay = delay * count + "ms";
  });
};

const marquee__init_2 = function () {
  if (!marqueeElements_2) {
    return;
  }

  window.addEventListener("resize", function () {
    marqueeElements_2.forEach(function (el) {
      // Setup animation times
      marquee__resize_2(el);
    });
  });

  // Repeating Logos and Text to make sure it fills the width of the view port
  const viewportWidth = window.innerWidth;
  const minWidth = (viewportWidth * 1) / 2;

  marqueeElements_2.forEach(function (el) {
    // If it's a logo marquee
    const tiles = el.querySelectorAll(".marquee__tile");
    const numTiles = tiles.length;
    const textWidth = tiles[0].offsetWidth * numTiles;
    const timesToRepeat = Math.ceil(minWidth / textWidth);

    const textToRepeat = el.innerHTML;

    for (let index = 1; index < timesToRepeat; index++) {
      el.innerHTML += textToRepeat;
    }

    // Wrapping the tiles
    el.innerHTML = "<div class='" + innerClass_2 + "'>" + el.innerHTML + "</div>";

    // Duplicating the wrap element
    const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
      repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

    repeatingTextClone.ariaHidden = "true";
    repeatingTextClone2.ariaHidden = "true";

    el.appendChild(repeatingTextClone);
    el.appendChild(repeatingTextClone2);

    // Force all lazy images within carousels to load immediately, otherwise they wont load
    const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
    marquee_lazyimgs.forEach(img => {
      LazyLoad.load(img);
    });

    // Setup animation times
    marquee__resize_2(el);

    // Once everything is set up, add "loaded" class
    el.classList.add(elClass_2 + "--loaded");
  });
};

// Defer loading this code until after page load
window.addEventListener("load", marquee__init_2);

// Defer loading this code until after page load
window.addEventListener("load", function () {
  /*  ==========================================================================
    Statistics - scroll effect
    ========================================================================== */

  function stats__init() {
    var $stats = $(".statistic__circle");
    if ($stats.length > 0) {
      $stats.each(function () {
        var $el = $(this);
        var $waypoint = new Waypoint({
          element: $el,
          handler: function (direction) {
            if (direction === "down") {
              var empty_fill = $el.find(".statistic__circle__emptyfill").css("background-color");
              var fill = $el.find(".statistic__circle__fill").css("background-color");
              var start_angle = -(3.141592653589793238 / 2); // (Math.PI / 2) - changed to number as Math.PI was throwing babel error
              $el.circleProgress({
                size: 500,
                thickness: 2,
                startAngle: start_angle,
                emptyFill: empty_fill,
                fill: {
                  color: fill
                }
              });
            }
          },
          offset: "95%"
        });
      });
    }
  } // stats__init()

  stats__init();

  /*  ==========================================================================
    Rellax Scroll animations - scroll effect
    ========================================================================== */

  function rellax__init() {
    var $rellax_items = $(".rellax");
    if ($rellax_items.length > 0) {
      var rellax = new Rellax(".rellax", {
        center: true
      });
    }
  } // rellax__init()

  rellax__init();
});

/*  ==========================================================================
    Scroll to anchor animations - scroll effect
    ========================================================================== */

$('a[href*="#"]:not([href="#"])').click(function () {
  if (
    location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") &&
    location.hostname === this.hostname
  ) {
    var target = $(".glossary__item" + this.hash);
    target = target.length ? target : $(".glossary__item[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      if ($(this).hasClass("glossary-nav__link")) {
        $("html, body").animate(
          {
            scrollTop: target.offset().top
          },
          1000
        );
      } else {
        $("html, body").animate(
          {
            scrollTop: target.offset().top - 200
          },
          1000
        );
      }
      return false;
    }
  }
});

/*  ==========================================================================
    Tabled Content
    ========================================================================== */

var acc = document.getElementsByClassName("table-content__mobile-link");
var i;

for (i = 0; i < acc.length; i++) {
  /* jshint ignore:start */
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    setTimeout(function () {
      Waypoint.refreshAll();
    }, 500);
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
  /* jshint ignore:end */
}

/*  ==========================================================================
    Scroll to the top 
    ========================================================================== */

// Get the button
let scrollToTopButton = document.querySelector(".scroll-to-top");

window.onscroll = function () {
  scrollFunction();
};

scrollToTopButton.onclick = function () {
  scrollToTop();
};

// When the user scrolls down 20px from the top of the document, show the button
function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    scrollToTopButton.classList.add("active");
  } else {
    scrollToTopButton.classList.remove("active");
  }
}

// When the user clicks the button it will smooth scroll to the top of the page.
function scrollToTop() {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
}

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
		========================================================================== */
/* jshint ignore:start */

var $grid_carousels = $(".row--carousel .owl-carousel:not(.media-nav)");

if ($grid_carousels.length > 0) {
  gridcarousel__init();
}

function gridcarousel__init() {
  $grid_carousels.each(function () {
    var $this = $(this);

    // Optional data attribute settings
    var $autoplay = $(this).data("autoplay") ? $(this).data("autoplay") : false;
    var $autoplay_timeout = $(this).data("autoplay-timeout") ? $(this).data("autoplay-timeout") : 5000;
    var $loop = $(this).data("loop") ? $(this).data("loop") : false;
    var $nav = $(this).data("nav") ? $(this).data("nav") : false;
    var $dots = $(this).data("dots") ? $(this).data("dots") : false;

    var responsive_array = carousel__responsive_array($this);
    $this.owlCarousel({
      autoplay: $autoplay,
      autoplayTimeout: $autoplay_timeout,
      loop: $loop,
      nav: $nav,
      dots: $dots,
      items: 4,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsive_array,
      autoHeight: true
    });

    $this.on("resized.owl.carousel", function (event) {
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
} // gridcarousel__init()

/*  ==========================================================================
			Media Nav Carousel
		========================================================================== */

var $media_nav_carousels = $(".row--carousel .media-nav");

if ($media_nav_carousels.length > 0) {
  medianavcarousel__init();
}

function medianavcarousel__init() {
  $media_nav_carousels.each(function () {
    var $this = $(this);
    var parent = $(this).closest(".module--text-content-media-slider");

    $(parent).addClass("paul");

    // Optional data attribute settings
    var $autoplay = $(this).data("autoplay") ? $(this).data("autoplay") : false;
    var $autoplay_timeout = $(this).data("autoplay-timeout") ? $(this).data("autoplay-timeout") : 10000;
    var $loop = $(this).data("loop") ? $(this).data("loop") : false;
    var $nav = $(this).data("nav") ? $(this).data("nav") : false;
    var $dots = $(this).data("dots") ? $(this).data("dots") : false;

    var responsive_array = carousel__responsive_array($this);
    $this.owlCarousel({
      autoplay: $autoplay,
      autoplayTimeout: $autoplay_timeout,
      loop: $loop,
      nav: $nav,
      dots: $dots,
      items: 4,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsive_array,
      autoHeight: false
    });

    function updateClass() {
      let a = $(".owl-item.active-item");
      a.removeClass("active-item");
      a = a.next(".owl-item");
      if (a.length === 0) {
        a = $(".media-nav .owl-item").first();
        $this.trigger("to.owl.carousel", [0, 200]);
      }
      a.addClass("active-item");

      let b = $(".media-slider__item.active-item");
      b.removeClass("active-item");
      b = b.next(".media-slider__item");
      if (b.length === 0) {
        b = $(".media-slider .media-slider__item").first();
      }
      b.addClass("active-item");
    }

    var maxHeight = "";

    $(".media-slider__item").each(function () {
      maxHeight = maxHeight > $(this).find(".module__bd").height() ? maxHeight : $(this).find(".module__bd").height();
    });

    $(parent)
      .find(".media-slider__item .module")
      .css("height", maxHeight + "px");

    /// Video Player inside slider
    var isPaused = false;
    var $plyrs = $(".video-slider");

    if ($plyrs.length > 0) {
      $plyrs.each(function () {
        var plyr = $(this).find(".mediavideo__video");
        const vid = new Plyr(plyr, {
          controls: ["play", "progress", "mute", "current-time"],
          hideControls: true,
          invertTime: false,
          tooltips: { controls: false, seek: false }
        });
        vid.on("play", () => {
          $this.trigger("stop.owl.autoplay");
          isPaused = true;
          $this.addClass("pause");
        });
        vid.on("pause", () => {
          $this.trigger("play.owl.autoplay");
          isPaused = false;
          $this.removeClass("pause");
        });
        vid.on("ended", () => {
          $this.trigger("play.owl.autoplay");
          isPaused = false;
          $this.removeClass("pause");
        });
        $(document).on("click", ".owl-item", function () {
          vid.pause();
        });
      });
    }

    var $waypoint = new Waypoint({
      element: $this,
      handler: function (direction) {
        if (direction === "down") {
          $this.trigger("play.owl.autoplay");
          $(".media-slider .media-slider__item").first().addClass("active-item");
          $(".media-nav .owl-item").first().addClass("active-item");

          $this.on("dragged.owl.carousel", function (event) {
            $this.trigger("stop.owl.autoplay");
            isPaused = true;
            $this.addClass("pause");
            if (event.relatedTarget._drag.direction === "left") {
              $(".owl-item.active-item").next().addClass("active-item").prev().removeClass("active-item");
              var curr = $(".media-slider").find(".active-item");
              if (curr.next().length > 0) {
                // If you want to stop at last element
                curr.next().addClass("active-item");
                curr.removeClass("active-item");
              }
            } else {
              $(".owl-item.active-item").prev().addClass("active-item").next().removeClass("active-item");
              var curr = $(".media-slider").find(".active-item");
              if (curr.prev().length > 0) {
                // If you want to stop at last element
                curr.prev().addClass("active-item");
                curr.removeClass("active-item");
              }
            }
          });

          $(document).ready(function () {
            var myTimer = setInterval(function () {
              if (!isPaused) {
                updateClass();
              }
            }, 10000);

            $(document).on("click", ".owl-item", function () {
              var owlIndex = $(this).index();
              $(".owl-item").removeClass("active-item");
              $(this).addClass("active-item");
              $(".media-slider__item").removeClass("active-item");
              $(".media-slider__item--" + owlIndex).addClass("active-item");
              $this.trigger("to.owl.carousel", [owlIndex, 500, true]);
              $this.trigger("stop.owl.autoplay");
              isPaused = true;
              $this.addClass("pause");
            });
          });
          this.destroy();
        }
      },
      offset: "95%"
    });

    $this.on("resized.owl.carousel", function (event) {
      var maxHeight = "";
      $(".media-slider__item").each(function () {
        console.log(maxHeight);
        maxHeight = maxHeight > $(this).find(".module__bd").height() ? maxHeight : $(this).find(".module__bd").height();
      });

      $(parent)
        .find(".media-slider__item .module")
        .css("height", maxHeight + "px");

      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
} // medianavcarousel__init()

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carousel__responsive_array($this) {
  var classList = $this.find(".col").attr("class").split(/\s+/);
  var responsive_array = {};
  $.each(classList, function (index, item) {
    // if is col width class
    if (item.indexOf("col-") !== -1) {
      var item_width = 0;
      var items_items = 4;
      item = item.replace("col-", "");
      // get min width from col class
      let item_gridsize = item.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(item_gridsize)) {
        item = item.replace(item_gridsize + "-", "");
        item_width = $grid_sizes[item_gridsize];
      } else {
        item_width = 0;
      }
      // split rest of class into sections (this should now be something like "1-4")
      let item_class_sections = item.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      var item_items = "";
      if (item_class_sections[1]) {
        item_items = item_class_sections[1] / item_class_sections[0];
      } else {
        item_items = 1; // if there isn't a second number it must be a single grid
      }
      responsive_array[item_width] = {
        items: item_items
      };
    }
  });

  return responsive_array;
}
/* jshint ignore:end */

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

var $mobnav = $(".mobnav");
var $siteheaderbd = $(".siteheader__bd");
var $mobnavtoggle = $(".mobnav-toggle");
var mobnavopenclass = "mobnavopen";

function mobnav__init() {
  // Open mobnav on click the toggle
  $mobnavtoggle.on("click touchend", function (e) {
    e.preventDefault();
    if (!$("body").hasClass(mobnavopenclass)) {
      // IT'S NOT OPEN...
      $("body").addClass(mobnavopenclass);
    } else {
      // IT'S OPEN...
      $("body").removeClass(mobnavopenclass);
      // Close secondary and tertiary nav items
      $(".sitenav__item--hasdropdown, .sitenav__item--hastertiary").delay(500).removeClass("sitenav__item--open");
    }
  });
} // mobnav__init()

mobnav__init();

/*  ==========================================================================
    NAVIGATION - mobnav dropdowns
    ========================================================================== */

// Secondary
$(
  ".sitenav__item--hasdropdown .sitenav__item__dropdownarrow, .sitenav__item.sitenav__item--hasdropdown .sitenav__item__back"
).click(function (e) {
  e.preventDefault();
  $(this).closest(".sitenav__item").toggleClass("sitenav__item--open");
});

// Tertiary
$(".sitenav__item--hasdropdown .sitenav__item__tertiaryarrow").click(function (e) {
  e.preventDefault();
  $(this).closest(".sitenav__item").toggleClass("sitenav__item--open");
});

$(".sitenav__item--hastertiary .sitenav__item__back").click(function (e) {
  console.log("back clicked");
  e.preventDefault();
  $(this).parent(".sitenav__item").toggleClass("sitenav__item--open");
});

/*  ==========================================================================
    NAVIGATION - button gradient hover
    ========================================================================== */

$(".sitenav__btn").hover(
  function () {
    $(this).closest(".sitenav__item").addClass("sitenav__item--over");
  },
  function () {
    $(this).closest(".sitenav__item").removeClass("sitenav__item--over");
  }
);

/*  ==========================================================================
    NAVIGATION - Search form open - on mobile
    ========================================================================== */

$(".sitenav--mobdropdown .searchform").click(function (e) {
  e.preventDefault();
  $(this).toggleClass("searchform--open");
});

/*  ==========================================================================
    NAVIGATION - gradient on mouse move
    ========================================================================== */

// if ($(".mobnav__gradient").length) {
//   $("body").mousemove(function (e) {
//     handleMouseMove(e);
//   });
// }

// function handleMouseMove(event) {
//   var x = event.clientX;
//   var y = event.clientY;

//   $(".mobnav__gradient").css({
//     left: x,
//     top: y
//   });
// }

/*  ==========================================================================
    NAVIGATION - Open teritary links
    ========================================================================== */
var $tertiary_navigation = $(".sitenav__item__dropdown--wtertiary");

if ($tertiary_navigation.length > 0) {
  tertiary_navigation__init();
}
function tertiary_navigation__init() {
  $(".sitenav__item__dropdown--wtertiary .secondary__link").hover(function () {
    var hover_id = $(this).data("hover-id");
    var teritary_parent_container = $(this).closest(".sitenav__item__dropdown--wtertiary");
    $(teritary_parent_container).find(".secondary__link").removeClass("secondary__link--active");
    $(this).addClass("secondary__link--active");
    $(teritary_parent_container).find(".tertiary__links").removeClass("tertiary__links--active");
    $("#" + hover_id).addClass("tertiary__links--active");
  });

  // Mobile Teriary
  $(".mobnav .secondary__link").click(function () {
    var hover_id = $(this).data("hover-id");
    console.log(hover_id);
  });
}

/*  ==========================================================================
    NAVIGATION - Open search
    ========================================================================== */

$(".search-toggle").click(function (e) {
  e.preventDefault();
  $(this).closest(".sitetopbar__item--search").toggleClass("sitetopbar__item--search--open");
});

/*  ==========================================================================
    NAVIGATION - When dropdown is too close to the edge
    ========================================================================== */

$(".sitenav:not(.sitenav--mobile) .sitenav__item--hasdropdown").on("mouseenter mouseleave", function (e) {
  if ($(".sitenav__item__dropdown", this).length) {
    var elm = $(".sitenav__item__dropdown:first", this);
    var off = elm.offset();
    var l = off.left;
    var w = elm.width();
    var docH = $(".siteheader").height();
    var docW = $(".siteheader").width();

    var isEntirelyVisible = l + w <= docW;
    if (!isEntirelyVisible) {
      $(this).addClass("sitenav__item--edge");
      var margin = l * 1.1;
      $(this)
        .find(".sitenav__item__dropdown")
        .css("margin-left", "-" + margin + "px");
    } else {
      $(this).removeClass("sitenav__item--edge");
    }
  }
});

/*  ==========================================================================
		Check Scroll
		========================================================================== */

function checkScroll() {
  if ($(window).scrollTop() > 50) {
    $(".siteheader").addClass("siteheader--scrolled");
    $("body").addClass("scrolled");
    $(".mobnav").addClass("mobnav--scrolled");
  } else {
    $(".siteheader").removeClass("siteheader--scrolled");
    $(".mobnav").removeClass("mobnav--scrolled");
    $("body").removeClass("scrolled");
  }
}

$(window).scroll(function () {
  checkScroll();
});

checkScroll();

/*  ==========================================================================
  Polyfill IE11 for forEach
  ========================================================================== */

if ("NodeList" in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}
